module.exports = __webpack_public_path__ + "media/img/logo@3x-34e45cf7.svg";